import { render, staticRenderFns } from "./InventoryForm.vue?vue&type=template&id=f1cd5c84&scoped=true&lang=html&"
import script from "./InventoryForm.vue?vue&type=script&lang=js&"
export * from "./InventoryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1cd5c84",
  null
  
)

export default component.exports